"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _TabScrollButton.default;
  }
});

var _TabScrollButton = _interopRequireDefault(require("./TabScrollButton"));


//////////////////
// WEBPACK FOOTER
// ./~/@material-ui/core/TabScrollButton/index.js
// module id = 201
// module chunks = 0